const bowser = require('bowser');

exports.defaultLocale = 'zh-hant';

exports.macOrWindows = () => {
    if (typeof window !== 'undefined') {
        const detect = bowser._detect(window.navigator.userAgent);
        if (detect.windows || detect.windowsPhone) {
            return 'win';
        }
    }
    return 'mac';
};

exports.isMobile = () => bowser.ios || bowser.android || bowser.blackberry || bowser.firefoxos;

const siteUrl = 'https://www.chientai.com.tw';
exports.siteUrl = siteUrl;

const withoutTrailing = (url) => url.slice(-1) !== '/';

exports.withoutTrailing = withoutTrailing;

const addTrailingSlash = (url) => {
    if (withoutTrailing(url)) {
        return `${url}/`;
    }
    return url;
};

exports.addTrailingSlash = addTrailingSlash;
